import React, { useEffect } from 'react';
import { connect as RConnect } from 'react-redux';
import styled from 'styled-components';
import { CircularProgress, Paper } from 'material-ui';
import subscriptionsActions from '../../actions/subscriptions';
import { animations } from '../../utils';

const connect = (props) => {
  // eslint-disable-next-line
  const { user: { email }, history, setOpenErrorCreditCardModal } = props;

  useEffect(() => {
    if (!email) {
      // eslint-disable-next-line react/prop-types
      history.push(`/login${window.location.search}`);
    } else {
      setOpenErrorCreditCardModal(true);

      // eslint-disable-next-line react/prop-types
      history.push('/dashboard');
    }
  }, []);


  const LoadingSpinner = () => (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minWidth: 590, minHeight: 240 }}
    >
      <CircularProgress size={60} thickness={7} />
    </div>
  );

  return (
    <Container className="d-flex justify-content-center align-items-center">
      <Box zDepth={3}>
        <Content className="d-flex flex-column align-items-center">
          <LoadingSpinner />
        </Content>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  min-width: 100vw;
  min-height: 100vh;
`;

const Box = styled(Paper)`
  width: 999px;
  height: 650px;
  animation: ${animations.fadeIn} 0.6s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 113px 40px;
`;

const Content = styled.div`
  font-family: DIN-Medium;
`;

export default RConnect(({ auth }) => ({
  user: auth.user,
}), {
  setOpenErrorCreditCardModal: subscriptionsActions.setOpenErrorCreditCardModal,
})(connect);
